<template>
  <div style="display:contents">
    <b-btn
      :id="`infoItemChecklist${itemId}`"
      v-b-tooltip.hover
      title="Informações"
      variant="none"
      class="btn-none rounded-pill icone-acao btn-outline-info"
      style="margin-right:0.3rem;"
      @click="mostrarInfo = true"
    >
      <feather-icon icon="InfoIcon" />
    </b-btn>
    <b-popover
      :id="`infoItemChecklist${itemId}`"
      :ref="`infoItemChecklist${itemId}`"
      placement="top"
      :target="`infoItemChecklist${itemId}`"
      triggers="click"
      custom-class="info-adicional-proposta"
      :show.sync="mostrarInfo"
    >
      <div slot="title">
        <span
          class="text-center"
          style="vertical-align: sub"
        >Informações adicionais</span>
        <b-button
          variant="none"
          class="close "
          @click="fecharInfo"
        >
          <span aria-hidden="true">&times;</span>
        </b-button>
      </div>
      <div>
        <b-row>
          <b-col cols="12">
            <span>{{ `Respondido por: ${item.usuCadastro ? item.usuCadastro : ''}` }}</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span>{{ `Data: ${item.dataCadastro ? item.dataCadastro : ''}` }}</span>
          </b-col>
        </b-row>
        <b-row v-if="item.justificativa && item.justificativa !== '' && item.usuAlteracao && item.usuAlteracao !== ''">
          <b-col cols="12">
            <span>{{ `Alterado por: ${item.usuAlteracao}` }}</span>
          </b-col>
        </b-row>
        <b-row v-if="item.justificativa && item.justificativa !== ''">
          <b-col cols="12">
            <span>{{ item.dataAlteracao ? `Data de alteração: ${item.dataAlteracao}` : '' }}</span>
          </b-col>
        </b-row>
        <b-row v-if="item.justificativa && item.justificativa !== '' && item.usuAlteracao && item.usuAlteracao !== ''">
          <b-col cols="12">
            <span>{{ `Justificativa: ${item.justificativa}` }}</span>
          </b-col>
        </b-row>
      </div>
    </b-popover>
  </div>
</template>

<style lang="scss">
.icone-acao {
  padding: 0.4rem;
}

.info-adicional-proposta {
   max-width: 100% !important;
}
</style>

<script>
export default {
  name: 'InfoChecklist',
  props: {
    itemId: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      mostrarInfo: false,
    }
  },
  methods: {
    fecharInfo() {
      this.mostrarInfo = false
    },
  },
}
</script>
